/**
 * Triggers a browser download of the given content as a file. Client-side only: wraps the content in a Blob,
 * creates a temporary object URL + anchor, clicks it, and cleans both up.
 *
 * `content` accepts any BlobPart, so this works for a CSV/text string as well as binary (e.g. a Uint8Array
 * decoded from a base64 payload).
 */
export var downloadBlob = function (filename, content, mimeType) {
    var url = URL.createObjectURL(new Blob([content], { type: mimeType }));
    var a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};
//# sourceMappingURL=download.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/download.js
// module id = 208
// module chunks = 0